import $ from 'jquery';
import { Controller } from '@hotwired/stimulus';
import '@/js/modules/jquery_datepicker_defaults';

export default class extends Controller {
  static targets = ['add', 'edit', 'label', 'picker', 'clear'];

  connect() {
    $(this.pickerTarget).datepicker({
      onSelect: (dateText) => {
        const dateFormat = $('meta[name="date-format"]').attr('content');
        const projectId = $('meta[name="project-id"]').attr('content');
        const dateParts = dateText.split(/[\/\-\.]/);
        let isoDate;

        if (dateFormat === 'mm/dd/yy' || dateFormat === 'mm/dd/yyyy') {
          isoDate = `${dateParts[2]}-${dateParts[0].padStart(2, '0')}-${dateParts[1].padStart(
            2,
            '0'
          )}`;
        } else if (dateFormat === 'dd/mm/yy' || dateFormat === 'dd/mm/yyyy') {
          isoDate = `${dateParts[2]}-${dateParts[1].padStart(2, '0')}-${dateParts[0].padStart(
            2,
            '0'
          )}`;
        } else if (dateFormat === 'yyyy/mm/dd' || dateFormat === 'yy/mm/dd') {
          isoDate = `${dateParts[0]}-${dateParts[1].padStart(2, '0')}-${dateParts[2].padStart(
            2,
            '0'
          )}`;
        }

        $.ajax({
          url: `/projects/${projectId}/update_due_date`,
          type: 'PATCH',
          data: { due_date: isoDate },
          success: (res) => {
            this.updateDueDate(res.due_date);
            this.closePicker();
          },
          error: () => {
            console.error('❌ Failed to update due date');
          },
        });
      },
    });

    this.boundClosePicker = this.closePicker.bind(this);
    this.boundHandleKeyDown = this.handleKeyDown.bind(this);
  }

  updateDueDate(dueDate) {
    this.addTarget.classList.add('hide');
    this.editTarget.classList.remove('hide');
    this.clearTarget.classList.remove('hide');

    const date = new Date(dueDate);
    const formattedDate = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

    this.labelTarget.textContent = formattedDate;
  }

  clearDueDate() {
    const projectId = $('meta[name="project-id"]').attr('content');

    $.ajax({
      url: `/projects/${projectId}/update_due_date`,
      type: 'PATCH',
      data: { due_date: null },
      success: () => {
        this.addTarget.classList.remove('hide');
        this.editTarget.classList.add('hide');
        this.clearTarget.classList.add('hide');
        this.closePicker();
      },
      error: () => {
        console.error('❌ Failed to update due date');
      },
    });
  }

  openPicker(event) {
    event.preventDefault();

    if (this.pickerTarget.classList.contains('hide')) {
      this.pickerTarget.classList.remove('hide');
      setTimeout(() => {
        document.addEventListener('click', this.boundClosePicker);
        document.addEventListener('keydown', this.boundHandleKeyDown);
      }, 0);
    }
  }

  closePicker(event) {
    if (event) {
      const target = event.target;
      const clickedInside =
        this.pickerTarget.contains(target) ||
        target.closest('.dashboard-due-date__picker') ||
        target.closest('.dashboard-due-date__clear') ||
        target.closest('.ui-datepicker-prev') ||
        target.closest('.ui-datepicker-next') ||
        target.closest('.ui-datepicker');

      if (clickedInside) {
        return;
      }
    }

    if (!this.pickerTarget.classList.contains('hide')) {
      this.pickerTarget.classList.add('hide');
      document.removeEventListener('click', this.boundClosePicker);
      document.removeEventListener('keydown', this.boundHandleKeyDown);
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.closePicker(event);
    }
  }
}
